import React from 'react';

import { FlowConditionAppBBWaardecheckContactRequestNew } from './types.flow';
import { WithBaseActionContextProps } from '~/scenes/Automation/Flows/Actions/BaseActionContext';
import { ConditionChoiceType } from '~/scenes/Automation/Flows/Actions/Base/FlowCondition/types.flow';

import { InputGroup } from '~/components/Inputs';
import TEST_ID from './Component.testid';
import { withBaseActionContext } from '~/scenes/Automation/Flows/Actions/BaseActionContext';
import { getStashVariablesInStash } from '~/scenes/Automation/Flows/Actions/util/stashHelpers';
import { FLOW_OUTPUT_TYPE } from '~/util/constants';
import { emptyBBWaardecheckReportEventParameterValue } from '../../FlowParameter/ParameterValue/Event';
import AppBBWaardecheckReportPointerComponent from '../../FlowParameter/ParameterValue/AppBBWaardecheckReportPointerComponent';

const text = {
  variableLabel: 'Selecteer brainbay waardecheck',
};
type MyProps = {
  condition: FlowConditionAppBBWaardecheckContactRequestNew;
  conditionChoiceType?: ConditionChoiceType | null | undefined;
  onChange: (
    newFlowCondition: FlowConditionAppBBWaardecheckContactRequestNew,
  ) => void;
};
type Props = WithBaseActionContextProps & MyProps;
type State = {
  key: string | null;
};
class FlowConditionAppBBWaardecheckContactRequestNewComponent extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      key: null,
    };
  }

  componentDidMount() {
    const { baseActionContext } = this.props;

    const key = baseActionContext.subscribeValidator({
      validate: this.validate,
    });

    this.setState({
      key,
    });
  }

  componentWillUnmount() {
    const { baseActionContext } = this.props;

    if (this.state.key != null) {
      baseActionContext.unsubscribeValidator(this.state.key);
    }
  }

  possibleBBWaardecheckReports = () => {
    const { baseActionContext } = this.props;
    const { variableStash } = baseActionContext;

    return getStashVariablesInStash(
      variableStash,
      FLOW_OUTPUT_TYPE.FlowOutputEventContactAppBbWaardecheckReport,
    );
  };

  validate = () =>
    // The pointer component will check if there is a selection and if that selection is correct
    true;

  render() {
    const { condition, onChange } = this.props;
    const { event } = condition;

    const possibleBBWaardecheckReports = this.possibleBBWaardecheckReports();

    if (possibleBBWaardecheckReports.length === 0) {
      return null;
    }

    return (
      <>
        <InputGroup data-testid={TEST_ID.EVENT_CONTAINER}>
          <AppBBWaardecheckReportPointerComponent
            variable={event?.variable ?? null}
            hideVariableDropdownIfOnlyOneOptionAndSelected
            hideFieldDropdownIfOnlyOneOptionAndSelected
            variableLabel={text.variableLabel}
            possibleVariables={possibleBBWaardecheckReports}
            fieldType={
              FLOW_OUTPUT_TYPE.FlowOutputEventContactAppBbWaardecheckReport
            }
            onChange={newPointerVariable => {
              const newValue: FlowConditionAppBBWaardecheckContactRequestNew = {
                ...condition,
                event: newPointerVariable
                  ? {
                      type: emptyBBWaardecheckReportEventParameterValue().type,
                      variable: newPointerVariable,
                    }
                  : null,
              };
              onChange(newValue);
            }}
          />
        </InputGroup>
      </>
    );
  }
}

export default withBaseActionContext<MyProps>(
  FlowConditionAppBBWaardecheckContactRequestNewComponent,
);
